/**
 * @see https://github.com/Everforth/growthpalette-front/issues/8922
 */
export interface SmbOrderConfirmViewEvent {
  event: 'smb_order_confirm_view'
  email: string
  phone: string
}

const createFromOrderConfirmViewEvent = (event: {
  email: string
  phone: string
}): SmbOrderConfirmViewEvent => ({
  event: 'smb_order_confirm_view',
  email: event.email,
  phone: event.phone,
})

export const smbOrderConfirmViewEventFactory = {
  createFromOrderConfirmViewEvent,
} as const
